export function formatOperationalDays(interval) {
    if (!interval) return "";
    const days = [];
    if (interval.monday) days.push("1");
    if (interval.tuesday) days.push("2");
    if (interval.wednesday) days.push("3");
    if (interval.thursday) days.push("4");
    if (interval.friday) days.push("5");
    if (interval.saturday) days.push("6");
    if (interval.sunday) days.push("7");

    const onlyOdd = interval.odd && !interval.even;
    const onlyEven = interval.even && !interval.odd;
    const onlyHolidays = interval.odd && interval.even && days.length === 0;

    if (onlyHolidays) return "praznici";
    let result = days.join(",");
    if (onlyOdd) result = result ? `${result} (neparni)` : "(neparni)";
    if (onlyEven) result = result ? `${result} (parni)` : "(parni)";
    return result;
}

export function formatTripsWithDays(trips) {
    if (!trips || trips.length === 0) return "";
    return trips
        .map((t) => {
            const time = t?.departureTime?.slice(0, -3) || "";
            const days = formatOperationalDays(t?.operationalInterval);
            return days ? `${time} [${days}]` : time;
        })
        .filter((s) => s)
        .join(", ");
}
